<template>
  <div class="container">
    <div class="title">抖音小程序营销券</div>
    <el-tabs v-model="activeIndex" @tab-click="handleClick">
      <el-tab-pane label="活动管理" name="1"></el-tab-pane>
      <el-tab-pane label="优惠券使用情况" name="2"></el-tab-pane>
    </el-tabs>
    <div v-show="activeIndex == '1'">
      <div class="tipBack">
        活动介绍：本活动优惠券适用于抖音小程序券的创建，创建后
        ID、使用链接、回调地址需要填入抖音控制台优惠券创建的内容中。
      </div>
      <div class="btns">
        <div class="btn theme" @click="createHandel">创建新优惠券</div>
        <el-button @click="exportTableColumn">导出数据</el-button>
      </div>
      <div>
        <el-table 
          v-loading="loading"
          :data="tableList.list"
          border
          highlight-current-row
          style="width: 100%"
          header-row-class-name="header"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            :index="indexMethod"
            align="center"
          />
          <el-table-column
            v-for="(item, index) in tableData"
            :key="index"
            :prop="item.value"
            :label="item.text"
            align="center"
            :width="
              [
                
                'useTimeRange',
                'createTime',
                'name'
              ].includes(item.value)
                ? 170
                : '' || ['usePath',
                'callBackUrl'].includes(item.value) ? 250 : ''
            "
          >
            <template slot-scope="{ row }">
              <span
                v-if="item.value === 'useTimeRange'"
              >
                <span>{{ row.grantTimeBegin }}</span>
                <br>
                <span>{{ row.grantTimeEnd }}</span>
              </span>
              <span
                v-else-if="item.value === 'status'"
                class="status"
                :class="row.status == 10 ? 'green' : ''"
              >
                {{row.statusStr}}
              </span>
              <span v-else>{{ row[item.value] }}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <span class="btn" @click="checkLook(row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
      >
      </el-pagination>
    </div>
    <div v-show="activeIndex == '2'">
      <couponDyDetail ref="couponDyDetailRef"></couponDyDetail>
    </div>
    <createCoupon ref="createCouponRef" @updateDy="updateDy"></createCoupon>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import createCoupon from "./createCoupon.vue";
import couponDyDetail from "./couponDyDetail.vue";
import { tableColumn } from "./enum";
export default {
  components: {
    createCoupon,
    couponDyDetail,
  },
  data() {
    return {
      activeIndex: "1",
      // 表头
      tableData: tableColumn,
      tableList:{},
      list: [],
      loading:false,
      searchForm:{
        pageSize: 10,
        pageNo: 1,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    checkLook(row) {
      this.$refs.createCouponRef.open(row);
    },
    updateDy() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      this.getList();
    },
    createHandel() {
      this.$refs.createCouponRef.open();
    },
    handleClick(tab, event) {
      // this.$nextTick(()=> {
      //   this.activeIndex = tab.name
      console.log(tab.name, event, "ee", this.activeIndex);
      // })
      if(tab.name == 1) {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.getList()
      }else if(tab.name == 2){
        // 优惠券使用情况
        this.$refs.couponDyDetailRef.init()
      }
    },
    async exportTableColumn() {
      let res = await MiniModel.openDyCouponExport()
      console.log(res,'导出')
      if(res.status == 200) {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "抖音活动管理导出_" + this.formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    // 抖音小程序券-优惠券管理
    async getList() {
      let params = {
        pageNo: this.searchForm.pageNo,
        pageSize: this.searchForm.pageSize,
      };
      this.loading = true
      const res = await MiniModel.searchCouponDy(params).finally(()=> {
        this.loading = false
      })
      console.log(res, "抖音小程序券-列表");
      if (res.data.code == 200) {
        this.tableList = res.data.data
        this.tableList.list = this.tableList.list.map(item => {
          console.log(item.getCount,'item.getCount')
          item.getCount = item.getCount ? item.getCount : 0
          item.useCount = item.useCount ? item.useCount : 0
          item.expireCount = item.expireCount ? item.expireCount : 0
          return item
        })
        // this.list = res.data.data.list;
      }
    },
    // 序号
    indexMethod(index) {
      index =
        index + 1 + (this.searchForm.pageNo - 1) * this.searchForm.pageSize;
      return index;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val;
      this.getList();
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  .title {
    color: #333 !important;
    font-size: 16px;
    font-weight: bold;
    // padding-top: 18px;
    padding: 8px 0 4px 0;
  }
}
.tipBack {
  display: block;
  padding: 10px 20px;
  margin-bottom: 10px;
  background: #f5f5f7;
  font-size: 12px;
}
.btn {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff8622;
  line-height: 18px;
  cursor: pointer;
  &.theme {
    width: 120px;
    height: 32px;
    background: #3d9efc;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.btns {
  display: flex;
  padding: 20px 0;
}
.status {
  display: block;
  position: relative;
  &::before {
    content: "";
    float: left;
    width: 6px;
    height: 6px;
    background: #ff8622;
    border-radius: 50%;
    margin-top: 8px;
  }
  &.green::before {
    background: #51c456;
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDy/index.vue